import * as types from './mutation-types'

export default {
    [types.AUTH_SUCCESS] (state, data) {
        state.token = data.token
        state.pseudo = data.pseudo
    },
}

